import { ValueOptions } from "@mui/x-data-grid-pro";
import { useMemo } from "react";
import { useQuery } from "../api";
import { getUserCompanies } from "../users/companies";

export function useUserCompanyOptions() {
  const [userCompanies] = useQuery(getUserCompanies);

  const userCompaniesOptions: ValueOptions[] | undefined = useMemo(() => {
    if (userCompanies) {
      const userCompanyOptionList = [{ value: "", label: "Any" }];
      const uco = userCompanies.map(({ id, name }) => ({
        value: id.toString(),
        label: name,
      }));
      userCompanyOptionList.push(...uco);
      return userCompanyOptionList;
    }
  }, [userCompanies]);

  return userCompaniesOptions;
}
